import {
  ALL_CATEGORIES_LABEL,
  canonicalCategoryName,
  getCategoryMeta,
} from "../config/productCategories";
import { getSalesbeezImageForCategory } from "../config/salesbeezCategoryImages";

/** Local tile art only (no Salesbeez hotlink). */
export function getLocalCategoryImageSrc(categoryName, overrides = {}) {
  if (!categoryName) return "/categories/all.svg";

  if (categoryName === ALL_CATEGORIES_LABEL) {
    return overrides[ALL_CATEGORIES_LABEL] || "/categories/all.svg";
  }

  const canonical = canonicalCategoryName(categoryName);
  if (overrides[canonical]) return overrides[canonical];

  const meta = getCategoryMeta(canonical);
  if (meta?.imageKey) return `/categories/${meta.imageKey}.svg`;

  return "/categories/other.svg";
}

export function getCategoryImageSrc(
  categoryName,
  overrides = {},
  salesbeezImages = {}
) {
  if (!categoryName) return "/categories/all.svg";

  if (categoryName === ALL_CATEGORIES_LABEL) {
    return (
      overrides[ALL_CATEGORIES_LABEL] ||
      getSalesbeezImageForCategory("Food & Beverages", salesbeezImages) ||
      "/categories/all.svg"
    );
  }

  const canonical = canonicalCategoryName(categoryName);

  const salesbeezUrl = getSalesbeezImageForCategory(canonical, salesbeezImages);
  if (salesbeezUrl) return salesbeezUrl;

  return getLocalCategoryImageSrc(categoryName, overrides);
}
